'use client';

import { TrackedAnchor } from '@/components/ancher';
import { TrackedButton } from '@/components/button';
import { TRACKED_EVENT_POSITION } from '@/constants';
import { useInquiryChat } from '@/components/channel-talk';
import { cn } from '@lib/utils';

import { HERO_SCROLL_TARGET } from './hero.constants';

const PRICE_INQUIRY_LABEL = 'hero_price-inquiry';

// 두 버튼 공통 캡슐 형태·크기 (모바일 14px / 데스크탑 22px)
const pillBase = cn(
  'inline-flex w-fit items-center justify-center rounded-[500px] border-2 border-transparent font-semibold transition-colors',
  'ring-offset-background focus-visible:ring-ring focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2',
  'h-10 px-5 text-[14px] leading-4 tracking-[-0.128px] md:h-16 md:px-[32px] md:text-[22px] md:leading-[30px] md:tracking-normal',
);

// hero 하단 버튼 2개:
// - 가격 문의: 채널톡 상담 열기(아웃라인)
// - 자세히 보기: 아래 검사 솔루션 영역(#solution)으로 페이지 내 스크롤(네이비)
export function HeroCtaButtons({
  priceLabel,
  detailLabel,
}: {
  priceLabel: string;
  detailLabel: string;
}) {
  const inquiryChatProps = useInquiryChat();

  return (
    <div className="flex min-h-[42px] items-center gap-2.5 md:min-h-[66px] md:gap-5">
      <TrackedButton
        label={PRICE_INQUIRY_LABEL}
        position={TRACKED_EVENT_POSITION.MAIN_HEADER}
        {...inquiryChatProps}
        className={cn(
          pillBase,
          'bg-[#EFF6FF] text-[#040435] hover:bg-[#040435] hover:text-white',
        )}
      >
        {priceLabel}
      </TrackedButton>

      <TrackedAnchor
        href={HERO_SCROLL_TARGET}
        label="hero_view-details"
        position={TRACKED_EVENT_POSITION.MAIN_HEADER}
        className={cn(pillBase, 'bg-[#040435] text-white hover:bg-[#FF1D1D]')}
      >
        {detailLabel}
      </TrackedAnchor>
    </div>
  );
}
